import { render, staticRenderFns } from "./DeleteDomainList.vue?vue&type=template&id=6a46004d"
import script from "./DeleteDomainList.vue?vue&type=script&lang=js"
export * from "./DeleteDomainList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports